import { FETCH_TUTORIAL_LIST } from './constants'

export const fetchTutorialList = {
  request: (deviceId) => ({ type: FETCH_TUTORIAL_LIST.REQUEST, deviceId }),
  success: (tutorials) => ({ type: FETCH_TUTORIAL_LIST.SUCCESS, tutorials })
}
